// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"cfdba8e4","122":"cab87917","230":"3652ba4a","328":"179a4a8f","390":"0ea3974c","616":"e1f4324d","624":"5e78124f","869":"dcd496b2","886":"092f5404","887":"cb6b2a50","900":"f6dbbcb7","953":"f039b51d"}[chunkId] + ".chunk.js";
};